"use strict";

var _regeneratorRuntime = require("/var/www/dev/prosper/admin.samsung-prosper.dev.pannovate.net/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _index = require("../../../../index");

var _CardModel = _interopRequireDefault(require("../../../../modules/cards/models/CardModel"));

var _UserModel = _interopRequireDefault(require("../../../../modules/users/all-users/models/UserModel"));

var _DateHelper = _interopRequireDefault(require("../../../../util/DateHelper"));

var _Api = _interopRequireDefault(require("../../../../logic/api/Api"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var CardsReports = /*#__PURE__*/function (_React$Component) {
  _inherits(CardsReports, _React$Component);

  function CardsReports() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CardsReports);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CardsReports)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      totalSchools: 0,
      totalProjects: 0,
      totalSupporters: 0,
      totalCollected: 0
    });

    return _this;
  }

  _createClass(CardsReports, [{
    key: "_filter",
    value: function _filter(filter) {
      this._tableComponent._filter(filter);
    }
  }, {
    key: "_loadWidget",
    value: function () {
      var _loadWidget2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(filter) {
        var result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return");

              case 3:
                result = _context.sent;
                this.setState(_objectSpread({}, result.data));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _loadWidget(_x) {
        return _loadWidget2.apply(this, arguments);
      }

      return _loadWidget;
    }()
  }, {
    key: "_getDownloadButton",
    value: function _getDownloadButton() {
      var _this2 = this;

      return _react["default"].createElement("a", {
        style: {
          minHeight: 50,
          display: 'flex',
          alignItems: 'center'
        },
        onClick: function onClick() {
          return _this2._triggerDownload();
        },
        className: "cancelBtn",
        href: "javascript:void(0)"
      }, _react["default"].createElement("i", {
        className: "fa fa-fw fa-download"
      }), " Download");
    }
  }, {
    key: "_triggerDownload",
    value: function () {
      var _triggerDownload2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var downloadLink;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                downloadLink = new _CardModel["default"]().getDownloadUrl();

                _Api["default"].downloadFile(downloadLink, {
                  filter: this._tableComponent.getFilter()
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _triggerDownload() {
        return _triggerDownload2.apply(this, arguments);
      }

      return _triggerDownload;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return _react["default"].createElement("div", null, _react["default"].createElement("h1", null, _react["default"].createElement("i", {
        className: "fa fa-credit-card",
        "aria-hidden": "true"
      }), " Reports - Cards"), _react["default"].createElement("div", {
        style: {
          backgroundColor: 'rgba(0, 0, 0, 0.4)',
          padding: 5,
          display: 'flex',
          flexDirection: 'row'
        }
      }, _react["default"].createElement("div", {
        style: {}
      }, this._getDownloadButton())), _react["default"].createElement(_index.AppTable, {
        onInit: function onInit(tableComponent) {
          return _this3._tableComponent = tableComponent;
        },
        title: "Cards" // headerActions={() => this._getDownloadButton()}
        ,
        onLoad: function onLoad(_ref) {
          var filter = _ref.filter;
          return _this3._loadWidget(filter);
        },
        model: _CardModel["default"],
        renderCell: function renderCell(column, item, index) {
          if (column.name == 'created') {
            return _DateHelper["default"].date(item.created, 'D / MMMM / Y');
          }

          if (column.name == 'modified') {
            return _DateHelper["default"].date(item.modified, 'D / MMMM / Y');
          }
        },
        getColumnActions: function getColumnActions(member, index) {
          return _react["default"].createElement("div", null, _react["default"].createElement(_reactRouterDom.Link, {
            to: "/cards/details/".concat(member.id),
            className: "button-info"
          }, "Details"));
        }
      }));
    }
  }]);

  return CardsReports;
}(_react["default"].Component);

exports["default"] = CardsReports;